<template>
  <div class="cart has_market_price">
    <Header />

    <div class="px-0 px-md-4 px-lg-0">
      <div class="pb-5 bg-custom">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="shopping-cart mt-4 px-4">
                <!-- Title -->
                <div class="title text-center">My Orders</div>

                <div class="table-responsive">
                  <table
                    class="table table-bordered border-dark"
                    style="min-width: 800px;"
                  >
                    <thead class="thead-light">
                      <tr>
                        <th class="text-center" scope="col">#</th>
                        <th scope="col">Item</th>
                        <th scope="col">Grade</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Total Cost</th>
                        <th align="center" scope="col" width="5%">[Action]</th>
                      </tr>
                    </thead>
                    <tbody
                      is="CartItem"
                      v-for="(cartItem_data, cart_serial) in cartItemData"
                      :key="cartItem_data.id"
                      :item="cartItem_data"
                      :serial="cart_serial"
                    ></tbody>
                  </table>
                </div>

                <div class="row mb-4">
                  <div class="col-md-12 text-center mb-3">
                    <button
                      class="btn btn-sm btn-pill btn-success px-3"
                      @click="addItem(null)"
                    >
                      + Add Item
                    </button>
                  </div>
                  <div class="col-md-8 col-lg-6 ml-auto">
                    <div class="d-md-flex align-items-center mb-2">
                      <label
                        for
                        class="d-block mt-2 text-black font-weight-bold"
                        style="min-width: 150px"
                        >Scheduled Delivery</label
                      >
                      <input
                        type="date"
                        v-model="deliveryInfo.date"
                        class="form-control border border-dark py-0 px-2 rounded-0"
                        name="date"
                        placeholder="Pick a single or multiple delivery dates"
                      />
                    </div>

                    <div class="d-md-flex align-items-center mb-2">
                      <label
                        for
                        class="d-block mt-2 text-black font-weight-bold"
                        style="min-width: 150px"
                        >Delivery Address</label
                      >
                      <textarea
                        class="w-100 form-control border border-dark px-2 rounded-0"
                        name="Address"
                        rows="1"
                        style="min-height: 38px;"
                        v-model="deliveryInfo.address"
                        placeholder="Enter Delivery Address"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="bg-white rounded-custom shadow-custom mt-4 p-0 p-md-4">
            <div class="row">
              <div class="col-lg-6">
                <div
                  class="bg-light rounded-pill px-4 py-3 text-uppercase font-weight-bold"
                >
                  Coupon code
                </div>
                <CartCoupon />
                <div
                  class="bg-light rounded-pill px-4 py-3 text-uppercase font-weight-bold"
                >
                  Instructions for seller
                </div>
                <CartInstruction />
              </div>
              <div class="col-lg-6">
                <div
                  class="bg-light rounded-pill px-4 py-3 text-uppercase font-weight-bold"
                >
                  Order summary
                </div>
                <CartSummary />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <market-price />

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import MarketPrice from "@/components/MarketPrice";
import CartItem from "@/components/cart/CartItem";
import CartCoupon from "@/components/cart/CartCoupon";
import CartInstruction from "@/components/cart/CartInstruction";
import CartSummary from "@/components/cart/CartSummary";
import { cartMixin } from "@/_mixins";
// import Footer from "@/components/Footer";

export default {
  mixins: [cartMixin],
  name: "Cart",
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | Cart",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },

  components: {
    Header,
    CartItem,
    CartCoupon,
    CartInstruction,
    CartSummary,
    MarketPrice
  },

  computed: {
    cartItemData() {
      return this.$store.state.cart.cart;
    }
  },

  data() {
    return {
      deliveryInfo: {
        date: "",
        address: ""
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.shopping-cart {
  margin: 0px auto;
  background: #ffffff;
  box-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;

  display: flex;
  flex-direction: column;
}

.shadow-custom {
  box-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.1);
}

.title {
  height: 60px;
  padding: 20px 30px;
  font-size: 18px;
  font-weight: 400;
}

.rounded-custom {
  border-radius: 6px;
}

/* Product Quantity */

button[class*="-btn"] {
  width: 30px;
  height: 30px;
  background-color: #e1e8ee;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

button:focus,
input:focus {
  outline: 0;
}

/* Responsive */
@media (max-width: 800px) {
  .shopping-cart {
    width: 100%;
    height: auto;
    overflow: hidden;
  }
}
</style>
